import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAttachmentDownloadUrlResponse, IAttachmentResponse } from '../dtos';
import { IAttachmentsApiClient } from './i-attachments-api.client';
import { ICreateAttachmentRequest } from '../dtos/requests';
import { CollectionApiClient } from '../../../../core';
import { UtilityManagementCollections } from '../../../..';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsApiClient implements IAttachmentsApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(UtilityManagementCollections.Attachments, http);
  }

  getById(id: string): Observable<IAttachmentDownloadUrlResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  getByIdDownloadUrl(id: string): Observable<IAttachmentDownloadUrlResponse> {
    return this.collectionApiClient.get({
      collectionName: UtilityManagementCollections.attachmentDownloadUrl(id)
    });
  }

  create(request: ICreateAttachmentRequest): Observable<string> {
    return this.collectionApiClient.post({
      body: request
    });
  }
}
